module.exports = __webpack_public_path__ + "img/shape-1-mobile-gold@2x.0449e19e.png";